function cov_vegbs927x() {
  var path = "/app/src/components/long-term-content/index.ts";
  var hash = "2d54a8fdb9a49e14add7383d26d0fab79df10b0a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2d54a8fdb9a49e14add7383d26d0fab79df10b0a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_vegbs927x = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_vegbs927x();
export { LongTermContent } from './long-term-content';